import { render, staticRenderFns } from "./create-stock-rotations-dialog.vue?vue&type=template&id=347f0357&"
import script from "./create-stock-rotations-dialog.vue?vue&type=script&lang=js&"
export * from "./create-stock-rotations-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports